<template>
  <div class="configuracion-impresiones py-4" :class="themeClass">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-xxl-9 col-xl-10">
          <div class="card shadow-sm border-0">
            <div class="card-header bg-gradient text-white d-flex justify-content-between align-items-center">
              <div>
                <h3 class="mb-0"><i class="bi bi-printer me-2"></i>Configuración de Impresiones</h3>
                <small class="text-white-50">Define el formato de impresión para tus comprobantes: RIDE o ticket térmico</small>
              </div>
            </div>
            <div class="card-body">

              <div v-if="cargando" class="text-center py-5">
                <div class="spinner-border text-primary"></div>
                <p class="text-muted mt-3">Cargando configuración...</p>
              </div>

              <template v-else>
                <div v-if="mensajeError" class="alert alert-danger d-flex justify-content-between align-items-center">
                  <span>{{ mensajeError }}</span>
                  <button type="button" class="btn-close" @click="mensajeError = ''"></button>
                </div>
                <div v-if="mensajeExito" class="alert alert-success d-flex justify-content-between align-items-center">
                  <span>{{ mensajeExito }}</span>
                  <button type="button" class="btn-close" @click="mensajeExito = ''"></button>
                </div>

                <!-- Tipo de impresión principal -->
                <section class="section-card">
                  <header class="section-card__header">
                    <div>
                      <h5 class="mb-0">Tipo de impresión predeterminado</h5>
                      <small class="text-muted">Selecciona el formato de impresión que se usará al generar comprobantes</small>
                    </div>
                  </header>
                  <div class="section-card__body">
                    <div class="row g-3">
                      <div class="col-md-6">
                        <div class="tipo-card" :class="{ activo: config.tipo === 'ride' }" @click="config.tipo = 'ride'">
                          <div class="tipo-card__icono">
                            <i class="bi bi-file-earmark-pdf fs-1 text-danger"></i>
                          </div>
                          <div class="tipo-card__info">
                            <h6 class="mb-1">RIDE (Documento PDF)</h6>
                            <small class="text-muted">Representación impresa del documento electrónico. Formato oficial SRI. Ideal para facturas formales.</small>
                          </div>
                          <div class="tipo-card__check">
                            <i class="bi bi-check-circle-fill text-primary fs-4" v-if="config.tipo === 'ride'"></i>
                            <i class="bi bi-circle text-muted fs-4" v-else></i>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="tipo-card" :class="{ activo: config.tipo === 'ticket' }" @click="config.tipo = 'ticket'">
                          <div class="tipo-card__icono">
                            <i class="bi bi-receipt fs-1 text-success"></i>
                          </div>
                          <div class="tipo-card__info">
                            <h6 class="mb-1">Ticket Térmico</h6>
                            <small class="text-muted">Formato compacto para impresoras de punto de venta (POS). Ideal para negocios con alto flujo de ventas.</small>
                          </div>
                          <div class="tipo-card__check">
                            <i class="bi bi-check-circle-fill text-primary fs-4" v-if="config.tipo === 'ticket'"></i>
                            <i class="bi bi-circle text-muted fs-4" v-else></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <!-- Configuración RIDE -->
                <section class="section-card" v-show="config.tipo === 'ride'">
                  <header class="section-card__header">
                    <div>
                      <h5 class="mb-0"><i class="bi bi-file-earmark-pdf me-1 text-danger"></i>Opciones del RIDE</h5>
                      <small class="text-muted">Ajusta el tamaño y orientación del documento PDF</small>
                    </div>
                  </header>
                  <div class="section-card__body">
                    <div class="row g-4">
                      <!-- Tamaño de papel -->
                      <div class="col-md-6">
                        <label class="form-label fw-semibold">Tamaño de papel</label>
                        <div class="paper-selector">
                          <div
                            v-for="papel in papeleRide"
                            :key="papel.valor"
                            class="paper-option"
                            :class="{ activo: config.ride.papel === papel.valor }"
                            @click="config.ride.papel = papel.valor"
                          >
                            <div class="paper-preview" :style="{ width: papel.previewW, height: papel.previewH }"></div>
                            <div class="paper-label">
                              <strong>{{ papel.etiqueta }}</strong>
                              <small class="text-muted d-block">{{ papel.dimensiones }}</small>
                            </div>
                            <i class="bi bi-check-circle-fill text-primary ms-auto" v-if="config.ride.papel === papel.valor"></i>
                          </div>
                        </div>
                      </div>

                      <!-- Opciones adicionales RIDE -->
                      <div class="col-md-6">
                        <label class="form-label fw-semibold">Opciones de contenido</label>
                        <div class="d-flex flex-column gap-3 mt-1">
                          <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" id="rideConLogo" v-model="config.ride.incluirLogo">
                            <label class="form-check-label" for="rideConLogo">
                              <strong>Incluir logo de empresa</strong>
                              <small class="text-muted d-block">El logo configurado en SRI aparecerá en el encabezado</small>
                            </label>
                          </div>
                          <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" id="rideConQR" v-model="config.ride.incluirQR">
                            <label class="form-check-label" for="rideConQR">
                              <strong>Incluir código QR de verificación</strong>
                              <small class="text-muted d-block">QR con enlace de verificación en el SRI</small>
                            </label>
                          </div>
                          <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" id="rideMensaje" v-model="config.ride.incluirMensaje">
                            <label class="form-check-label" for="rideMensaje">
                              <strong>Incluir mensaje personalizado</strong>
                              <small class="text-muted d-block">Texto configurado en la sección SRI</small>
                            </label>
                          </div>
                          <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" id="rideDetallePago" v-model="config.ride.detalleFormaPago">
                            <label class="form-check-label" for="rideDetallePago">
                              <strong>Mostrar detalle de forma de pago</strong>
                            </label>
                          </div>
                        </div>
                      </div>

                      <!-- Márgenes -->
                      <div class="col-md-12">
                        <label class="form-label fw-semibold">Márgenes (mm)</label>
                        <div class="row g-2">
                          <div class="col-md-3">
                            <label class="form-label small">Superior</label>
                            <input type="number" class="form-control" v-model.number="config.ride.margenSuperior" min="0" max="50" />
                          </div>
                          <div class="col-md-3">
                            <label class="form-label small">Inferior</label>
                            <input type="number" class="form-control" v-model.number="config.ride.margenInferior" min="0" max="50" />
                          </div>
                          <div class="col-md-3">
                            <label class="form-label small">Izquierdo</label>
                            <input type="number" class="form-control" v-model.number="config.ride.margenIzquierdo" min="0" max="50" />
                          </div>
                          <div class="col-md-3">
                            <label class="form-label small">Derecho</label>
                            <input type="number" class="form-control" v-model.number="config.ride.margenDerecho" min="0" max="50" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <!-- Configuración Ticket -->
                <section class="section-card" v-show="config.tipo === 'ticket'">
                  <header class="section-card__header">
                    <div>
                      <h5 class="mb-0"><i class="bi bi-receipt me-1 text-success"></i>Opciones del Ticket Térmico</h5>
                      <small class="text-muted">Configura el ancho del papel de tu impresora POS</small>
                    </div>
                  </header>
                  <div class="section-card__body">
                    <div class="row g-4">
                      <!-- Ancho del papel -->
                      <div class="col-md-6">
                        <label class="form-label fw-semibold">Ancho del papel</label>
                        <div class="d-flex flex-column gap-3 mt-1">
                          <div
                            v-for="ancho in anchosTicket"
                            :key="ancho.valor"
                            class="ticket-option"
                            :class="{ activo: config.ticket.ancho === ancho.valor }"
                            @click="config.ticket.ancho = ancho.valor"
                          >
                            <div class="ticket-preview" :style="{ width: ancho.previewW, height: '60px' }"></div>
                            <div class="ms-3">
                              <strong>{{ ancho.etiqueta }}</strong>
                              <small class="text-muted d-block">{{ ancho.descripcion }}</small>
                            </div>
                            <i class="bi bi-check-circle-fill text-primary ms-auto" v-if="config.ticket.ancho === ancho.valor"></i>
                          </div>
                        </div>
                      </div>

                      <!-- Opciones de ticket -->
                      <div class="col-md-6">
                        <label class="form-label fw-semibold">Opciones de contenido</label>
                        <div class="d-flex flex-column gap-3 mt-1">
                          <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" id="ticketLogo" v-model="config.ticket.incluirLogo">
                            <label class="form-check-label" for="ticketLogo">
                              <strong>Imprimir logo de empresa</strong>
                              <small class="text-muted d-block">Se imprimirá en la cabecera del ticket</small>
                            </label>
                          </div>
                          <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" id="ticketQR" v-model="config.ticket.incluirQR">
                            <label class="form-check-label" for="ticketQR">
                              <strong>Imprimir código QR</strong>
                              <small class="text-muted d-block">QR de verificación SRI al pie del ticket</small>
                            </label>
                          </div>
                          <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" id="ticketMensaje" v-model="config.ticket.incluirMensaje">
                            <label class="form-check-label" for="ticketMensaje">
                              <strong>Imprimir mensaje personalizado</strong>
                            </label>
                          </div>
                          <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" id="ticketCorteAuto" v-model="config.ticket.corteAutomatico">
                            <label class="form-check-label" for="ticketCorteAuto">
                              <strong>Corte automático de papel</strong>
                              <small class="text-muted d-block">Requiere impresora con soporte de corte automático</small>
                            </label>
                          </div>
                        </div>

                        <!-- Tamaño de fuente -->
                        <div class="mt-3">
                          <label class="form-label fw-semibold">Tamaño de fuente</label>
                          <select class="form-select" v-model="config.ticket.tamanoFuente">
                            <option value="pequeño">Pequeño (7pt)</option>
                            <option value="normal">Normal (9pt)</option>
                            <option value="grande">Grande (11pt)</option>
                          </select>
                        </div>
                      </div>

                      <!-- Vista previa del ticket -->
                      <div class="col-12">
                        <label class="form-label fw-semibold">Vista previa del ticket</label>
                        <div class="ticket-preview-container">
                          <div class="ticket-preview-doc" :style="{ width: anchoPreviewTicket }">
                            <div class="text-center fw-bold" style="font-size: 0.85em;">COMERCIAL DEMO S.A.</div>
                            <div class="text-center small text-muted">RUC: 1790012345001</div>
                            <div class="text-center small text-muted">Av. Amazonas N34-101, Quito</div>
                            <hr class="my-1">
                            <div class="small text-center fw-bold">FACTURA ELECTRÓNICA</div>
                            <div class="small">N.° 001-001-000000125</div>
                            <div class="small">Fecha: 17/03/2026</div>
                            <div class="small">Cliente: Juan Pérez</div>
                            <hr class="my-1">
                            <div class="small">2x Producto A.....$10.00</div>
                            <div class="small">1x Producto B......$5.50</div>
                            <hr class="my-1">
                            <div class="small d-flex justify-content-between"><span>Subtotal:</span><span>$15.50</span></div>
                            <div class="small d-flex justify-content-between"><span>IVA 15%:</span><span>$2.33</span></div>
                            <div class="small fw-bold d-flex justify-content-between"><span>TOTAL:</span><span>$17.83</span></div>
                            <hr class="my-1">
                            <div class="text-center small text-muted">¡Gracias por su compra!</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <div class="d-flex justify-content-end gap-2 mt-2">
                  <button class="btn btn-outline-secondary" @click="cargarDatos">
                    <i class="bi bi-arrow-clockwise me-1"></i>Recargar
                  </button>
                  <button class="btn btn-primary px-4" @click="guardar" :disabled="guardando">
                    <span v-if="guardando" class="spinner-border spinner-border-sm me-2"></span>
                    Guardar configuración
                  </button>
                </div>

              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import themeManager from '@/store/theme'
import api from '@/services/api'

export default {
  name: 'ClientConfiguracionImpresiones',
  data() {
    return {
      cargando: true,
      guardando: false,
      mensajeError: '',
      mensajeExito: '',
      config: {
        tipo: 'ride',
        ride: {
          papel: 'A4',
          incluirLogo: true,
          incluirQR: true,
          incluirMensaje: true,
          detalleFormaPago: true,
          margenSuperior: 15,
          margenInferior: 15,
          margenIzquierdo: 15,
          margenDerecho: 15
        },
        ticket: {
          ancho: '80mm',
          incluirLogo: true,
          incluirQR: true,
          incluirMensaje: true,
          corteAutomatico: false,
          tamanoFuente: 'normal'
        }
      },
      papeleRide: [
        { valor: 'A4', etiqueta: 'A4',  dimensiones: '210 × 297 mm — Estándar carta', previewW: '28px', previewH: '40px' },
        { valor: 'A5', etiqueta: 'A5',  dimensiones: '148 × 210 mm — Media carta',   previewW: '20px', previewH: '28px' }
      ],
      anchosTicket: [
        { valor: '58mm', etiqueta: '58 mm', descripcion: 'Impresoras compactas de bolsillo o sobremesa pequeña', previewW: '30px' },
        { valor: '80mm', etiqueta: '80 mm', descripcion: 'Impresoras estándar POS — la más común en negocios',   previewW: '44px' }
      ]
    }
  },
  computed: {
    themeClass() {
      return themeManager.themeClass
    },
    anchoPreviewTicket() {
      return this.config.ticket.ancho === '58mm' ? '160px' : '220px'
    }
  },
  created() {
    this.cargarDatos()
  },
  methods: {
    async cargarDatos() {
      this.cargando = true
      try {
        const res = await api.get('/configuracion/impresiones')
        const datos = res?.data?.data || res?.data || {}
        if (datos.tipo) this.config.tipo = datos.tipo
        if (datos.ride)   Object.assign(this.config.ride,   datos.ride)
        if (datos.ticket) Object.assign(this.config.ticket, datos.ticket)
      } catch {
        // Usa los valores por defecto si no hay configuración guardada
      } finally {
        this.cargando = false
      }
    },

    async guardar() {
      this.guardando = true
      this.mensajeError = ''
      this.mensajeExito = ''
      try {
        await api.post('/configuracion/impresiones', this.config)
        this.mensajeExito = 'Configuración de impresiones guardada correctamente.'
      } catch (error) {
        this.mensajeError = error?.response?.data?.error || error?.message || 'No se pudo guardar la configuración.'
      } finally {
        this.guardando = false
      }
    }
  }
}
</script>

<style scoped>
.configuracion-impresiones {
  --primary-color: #1173d4;
  --body-bg: #f5f7fb;
  --card-bg: #ffffff;
  --border-color: rgba(17, 115, 212, 0.1);
  --text-primary: #1f2933;
  --text-secondary: #4a5568;
  background-color: var(--body-bg);
  min-height: 100vh;
  padding-bottom: 2rem;
}

.configuracion-impresiones.dark-theme {
  --body-bg: #0b1320;
  --card-bg: #111d30;
  --border-color: rgba(148, 163, 184, 0.18);
  --text-primary: #e2e8f0;
  --text-secondary: #cbd5f5;
}

.card {
  background-color: var(--card-bg);
  border-color: var(--border-color);
  color: var(--text-primary);
}

.bg-gradient {
  background: linear-gradient(135deg, rgba(17, 115, 212, 0.95) 0%, rgba(40, 137, 235, 0.9) 100%);
}

.section-card {
  border: 1px solid var(--border-color);
  border-radius: 18px;
  padding: 1.6rem;
  margin-bottom: 1.4rem;
  background-color: var(--card-bg);
  color: var(--text-primary);
  box-shadow: 0 10px 24px -18px rgba(15, 46, 70, 0.28);
}

.configuracion-impresiones.dark-theme .section-card { box-shadow: none; }

.section-card__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.2rem;
}

.section-card__header h5 { font-weight: 700; }

/* Tarjetas de selección de tipo */
.tipo-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.2rem;
  border: 2px solid var(--border-color);
  border-radius: 14px;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
  background-color: var(--card-bg);
  height: 100%;
}

.tipo-card:hover {
  border-color: rgba(17, 115, 212, 0.4);
  box-shadow: 0 4px 16px rgba(17, 115, 212, 0.1);
}

.tipo-card.activo {
  border-color: var(--primary-color);
  box-shadow: 0 4px 20px rgba(17, 115, 212, 0.2);
}

.tipo-card__info { flex: 1; }
.tipo-card__info h6 { margin-bottom: 0.3rem; font-weight: 700; }

/* Selector de papel RIDE */
.paper-selector { display: flex; flex-direction: column; gap: 0.75rem; }

.paper-option {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 1rem;
  border: 2px solid var(--border-color);
  border-radius: 12px;
  cursor: pointer;
  transition: border-color 0.2s;
  background-color: var(--card-bg);
}

.paper-option.activo { border-color: var(--primary-color); }

.paper-preview {
  background: White;
  border: 1.5px solid #adb5bd;
  border-radius: 2px;
  flex-shrink: 0;
}

/* Opciones de ticket */
.ticket-option {
  display: flex;
  align-items: center;
  gap: 0;
  padding: 0.75rem 1rem;
  border: 2px solid var(--border-color);
  border-radius: 12px;
  cursor: pointer;
  transition: border-color 0.2s;
  background-color: var(--card-bg);
}

.ticket-option.activo { border-color: var(--primary-color); }

.ticket-preview {
  background: White;
  border: 1.5px solid #adb5bd;
  border-radius: 2px;
  flex-shrink: 0;
}

/* Vista previa del ticket */
.ticket-preview-container {
  display: flex;
  justify-content: center;
  padding: 1.5rem;
  background: #e9ecef;
  border-radius: 12px;
}

.configuracion-impresiones.dark-theme .ticket-preview-container {
  background: rgba(15, 23, 42, 0.5);
}

.ticket-preview-doc {
  background: #fff;
  padding: 12px;
  border-radius: 3px;
  font-family: 'Courier New', monospace;
  font-size: 0.78rem;
  color: #000;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  transition: width 0.3s;
}

.form-control,
.form-select {
  background-color: var(--card-bg);
  color: var(--text-primary);
  border-color: rgba(148, 163, 184, 0.4);
  border-radius: 10px;
}

.form-control:focus,
.form-select:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(17, 115, 212, 0.15);
  background-color: var(--card-bg);
}

.configuracion-impresiones.dark-theme .form-control,
.configuracion-impresiones.dark-theme .form-select {
  background-color: rgba(15, 23, 42, 0.6);
  border-color: rgba(148, 163, 184, 0.3);
  color: var(--text-primary);
}
</style>
